import { Autocomplete, Button, CircularProgress, TextField } from '@mui/material';
import { FC, useState } from 'react';

import { useCreateKundeMutation, useFindAllKundeQuery } from '../../api/kundeApi';
import { KontaktTyp, Kunde } from '../../api/types';

interface KundeAutocompleteProps {
  value?: string | null;
  onChange: (kundeId: string | null) => void;
  error?: string;
  required?: boolean;
}

export const KundeAutocomplete: FC<KundeAutocompleteProps> = ({
  value,
  onChange,
  error,
  required,
}) => {
  const { data: kunden = [], isFetching: isFetchingList } = useFindAllKundeQuery();
  const [createKunde, { isLoading: isCreatingKunde }] = useCreateKundeMutation();

  const [inputValue, setInputValue] = useState('');

  const handleCreateKunde = () =>
    //createKunde({organisation: inputValue, operativerAnsprechpartner: null, adresse: null})
    createKunde({
      typ: KontaktTyp.KUNDE,
      organisation: inputValue,
      operativerAnsprechpartner: null,
      email: null,
      telefonnummer: null,
      quelle: null,
      vertriebsStatus: null,
      angebotsnummer: null,
      angebotslink: null,
      bemerkung: null,
      zuletztBearbeitet: null,
      stadt: null,
      postleitzahl: null,
      strasse: null,
      hausnummer: null,
      adresszusatz: null,
    })
      .unwrap()
      .then(kunde => {
        onChange(kunde.id);
      });

  return (
    <Autocomplete
      value={kunden.find(k => k.id === value) ?? null}
      renderInput={params => (
        <TextField
          {...params}
          label="Kunde"
          variant="outlined"
          error={Boolean(error)}
          helperText={error}
          required={required}
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,
              endAdornment: (
                <>
                  {isFetchingList || isCreatingKunde ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.slotProps.input.endAdornment}
                </>
              ),
            },
          }}
        />
      )}
      options={kunden}
      getOptionLabel={o => o.organisation}
      inputValue={inputValue}
      onInputChange={(_, v) => {
        setInputValue(v);
      }}
      onChange={(_, value) => {
        const kunde: Kunde | null = value;
        if (kunde) {
          onChange(kunde.id);
        } else {
          onChange(null);
        }
      }}
      noOptionsText={
        inputValue !== '' ? (
          <Button
            disabled={isCreatingKunde || isFetchingList}
            color="primary"
            variant="contained"
            style={{ textTransform: 'none' }}
            onMouseDown={handleCreateKunde}
          >
            Neuer Kunde &quot;{inputValue}&quot;
          </Button>
        ) : (
          ''
        )
      }
    />
  );
};
